import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["page", "setPage", "isAnyFilterSelected"];
// @ts-expect-error Could not find a declaration file for module
import { useSearchParam } from '../../hooks/searchParamHooks';
import { FILTER_TYPES, FILTER_TYPES_OTHER } from '../../constants/TopFilterConstants';
import getLang from 'academy-common-lib/utils/getLang';
import { CategoriesSubSections, HubspotToolsSubSections, SEARCH_FILTERS } from './searchConsts';
import { matchPath, useLocation } from 'react-router-dom';
import { useLearningContentCardModels } from 'academy-common-lib/features/cards/hooks/useLearningContentCardModels';
import { usePagination } from '../pagination/paginationHooks';
import { PAGE_SIZE } from '../pagination/paginationConsts';
import { useSearch } from 'academy-common-lib/features/search/hooks/useSearch';
import { useSearchRecencyScoringConfig } from './searchExperiments';
import { MYLEARNING_URL_FRAGMENT } from '../../constants/Navigation';
export const useCatalogSearchParams = () => {
  const {
    search: searchParams
  } = useLocation();
  const {
    currentPage: page,
    setPage
  } = usePagination();
  const [languages] = useSearchParam(FILTER_TYPES.LANGUAGE);
  const [[search]] = useSearchParam(FILTER_TYPES_OTHER.SEARCH);
  const [categories] = useSearchParam(FILTER_TYPES_OTHER.CATEGORIES);
  const [durations] = useSearchParam(FILTER_TYPES.DURATION);
  const [hubSpotSoftware] = useSearchParam(FILTER_TYPES_OTHER.TOOLS);
  const [levels] = useSearchParam(FILTER_TYPES.LEVEL);
  const [contentTypes] = useSearchParam(FILTER_TYPES.CONTENT_TYPE);
  const [[contentSource]] = useSearchParam(FILTER_TYPES.CONTENT_SOURCE);
  const [[hasAwardsOnly]] = useSearchParam(FILTER_TYPES.AWARD_TYPE);
  const [[sortingType]] = useSearchParam(FILTER_TYPES.SORT_BY);
  const urlParams = new URLSearchParams(searchParams);
  const isAnyFilterSelected = SEARCH_FILTERS.some(filter => urlParams.has(filter));
  const mappedContentTypes = contentTypes === null || contentTypes === void 0 ? void 0 : contentTypes.map(type => type === 'COURSE' ? 'TRACK' : type);
  return {
    page: page || 1,
    setPage,
    isAnyFilterSelected,
    languages: languages !== null && languages !== void 0 && languages.length ? languages : [getLang().toUpperCase()],
    search: search !== null && search !== void 0 && search.length ? search : undefined,
    categories: categories !== null && categories !== void 0 && categories.length ? categories : undefined,
    durations: durations !== null && durations !== void 0 && durations.length ? durations : undefined,
    hubSpotSoftware: hubSpotSoftware !== null && hubSpotSoftware !== void 0 && hubSpotSoftware.length ? hubSpotSoftware : undefined,
    levels: levels !== null && levels !== void 0 && levels.length ? levels : undefined,
    contentTypes: mappedContentTypes !== null && mappedContentTypes !== void 0 && mappedContentTypes.length ? mappedContentTypes : undefined,
    sortingType,
    hasAwardsOnly: hasAwardsOnly === 'ONLY_SHOW_CERTIFICATE_COURSES' ? true : undefined,
    visibilityGroup: contentSource
  };
};
export const useIsCatalogSearchPage = () => {
  const location = useLocation();
  const isCatalogResultsPage = location.pathname.match(/^\/results\/?$/i);
  return isCatalogResultsPage;
};
export const useIsPartnerSearchPage = () => {
  const location = useLocation();
  const isPartnerSearchPage = location.pathname.match(/^\/partners\/?$/i);
  return isPartnerSearchPage;
};
export const useIsMyLearningPage = () => {
  const {
    pathname
  } = useLocation();
  return !!matchPath(pathname, {
    path: MYLEARNING_URL_FRAGMENT
  });
};
export const useCatalogSearchResults = ({
  partnersOnly,
  pageSize = PAGE_SIZE,
  contentTypes,
  skip
} = {}) => {
  var _searchCriteria$conte;
  const _useCatalogSearchPara = useCatalogSearchParams(),
    {
      page,
      setPage,
      isAnyFilterSelected
    } = _useCatalogSearchPara,
    searchCriteria = _objectWithoutPropertiesLoose(_useCatalogSearchPara, _excluded);
  const {
    scoringConfig,
    isLoadingSearchRecencyScoringConfig
  } = useSearchRecencyScoringConfig();
  const categoryGroup = searchCriteria.categories ? searchCriteria.categories[0] : undefined;
  if (categoryGroup && CategoriesSubSections[categoryGroup]) {
    searchCriteria.categories = CategoriesSubSections[categoryGroup];
  }
  const softwareGroup = searchCriteria.hubSpotSoftware ? searchCriteria.hubSpotSoftware[0] : undefined;
  if (softwareGroup && HubspotToolsSubSections[softwareGroup]) {
    searchCriteria.hubSpotSoftware = HubspotToolsSubSections[softwareGroup];
  }
  if (contentTypes && !((_searchCriteria$conte = searchCriteria.contentTypes) !== null && _searchCriteria$conte !== void 0 && _searchCriteria$conte.length)) {
    searchCriteria.contentTypes = contentTypes;
  }
  const visibilityGroup = searchCriteria.visibilityGroup === 'ALL_CONTENT' ? undefined : searchCriteria.visibilityGroup;
  const variables = Object.assign({}, searchCriteria, {
    pageLength: pageSize,
    partnersOnly,
    shouldFilterDeprecated: true,
    offset: {
      cursor: (page - 1) * pageSize
    },
    visibilityGroup
  });
  const {
    searchResults,
    searchResultsLoading,
    searchResultsError,
    totalCount,
    correlationId
  } = useSearch({
    variables,
    skip: skip || isLoadingSearchRecencyScoringConfig,
    scoringConfig
  });
  const {
    cardModels,
    cardModelsLoading,
    cardModelsError
  } = useLearningContentCardModels({
    items: (searchResults === null || searchResults === void 0 ? void 0 : searchResults.map(item => {
      const {
        id,
        contentType
      } = item;
      return {
        id: id,
        type: contentType === 'TEMPLATE' || contentType === 'EBOOK' ? 'LESSON' : contentType,
        language: 'language' in item ? item.language : undefined,
        resultMLOptionId: item.resultMLOptionId
      };
    })) || [],
    skip: !searchResults
  });
  return {
    results: cardModels,
    loading: searchResultsLoading || cardModelsLoading || isLoadingSearchRecencyScoringConfig,
    error: searchResultsError || cardModelsError,
    page,
    setPage,
    totalCount,
    isAnyFilterSelected,
    searchCriteria,
    correlationId
  };
};